<template>
  <ul class="selectTab">
    <li
      v-for="item in paymentMethod"
      :key="item.value"
      @click="$emit('click', item.value)"
      class="selectTab__item"
      :class="{'selectTab__item--active': select === item.value}"
    >
      {{ item.text }}
    </li>
  </ul>
</template>

<script>
export default {
  name: 'SubscSelectPaymentMethod',
  data() {
    return {
      // 支払い方法
      paymentMethod: [
        { value: 'credit', text: 'クレジットカード' },
        { value: 'amazonpay', text: 'Amazon Pay' },
      ],
    }
  },
  props: {
    // 選択中の支払い方法
    select: {
      type: String,
      default: '',
    }
  },
  created() {
    if (!this.select) { this.paymentMethod[0].value }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/commons/commonVariables.scss";
.selectTab {
  display: flex;
  box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.15);
  margin: 0 auto 28px;
  padding: 0;
  font-weight: bold;
  font-size: 12px;
  line-height: 1;
  text-align: center;
  border-radius: 4px;
  &__item {
    list-style: none;
    flex: 1 1 50%;
    cursor: pointer;
    height: 36px;
    line-height: 36px;
    background: #FFFFFF;
    &:first-child {
      border-radius: 4px 0 0 4px;
    }
    &:last-child {
      border-radius: 0 4px 4px 0;
    }
    &--active {
      background: linear-gradient(92.4deg, #FF7497 18.23%, #CB8BFF 80.21%);
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/SubscSelectPaymentMethod.vue